import { commonBase } from '@kid/meta-color/color/output/all';
import { useStyle } from '../../hooks/useStyle';
export function useSwitchStyle() {
    const switchStyle = useStyle({
        roundWhite: {
            width: 27,
            height: 27,
            borderRadius: 27 / 2,
            backgroundColor: commonBase.kiui_color_base_white_1,
        },
        roundRed: {
            width: 22,
            height: 22,
            borderRadius: 22 / 2,
            backgroundColor: commonBase.kiui_color_base_red_1,
        },
        track: {
            height: 31,
            width: 51,
            borderRadius: 31 / 2,
            paddingHorizontal: 2,
            justifyContent: 'center',
        },
        trackChecked: {
            backgroundColor: commonBase.kiui_color_base_red_1,
            // alignItems: 'flex-end',
        },
        trackUnchecked: {
            backgroundColor: commonBase.kiui_color_base_blue_1_a16,
            // alignItems: 'flex-start',
        },
        trackLightRed: {
            height: 31,
            backgroundColor: commonBase.kiui_color_base_red_1,
        },
    });
    return {
        switchStyle,
    };
}
